import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaFileDownload, FaLess, FaMinus, FaPlus, FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import styles from "./distribuidor.module.css";
import { IoClose, IoCloseSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../../utils/services/api';
import { FUNTIONS, SERVICE } from '../../utils/constants/services';
import Select from 'react-select'
import { AiFillDelete } from 'react-icons/ai';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { BsFileEarmarkPdfFill } from 'react-icons/bs';
import ModalPDF from '../clientes/clientesModalPDF';


export default function ModalDistribuidores(props) {
    const { show, setShow, roles, dataEdit, setDataEdit, municipios, estados, codigos, ofices, coordinadores, handleUpdate, maritalEstatus, genders, asesores, addressTypes, documentTypes, referenceTypes, questions } = props;
    const [name, setName] = useState("");
    const [direccion, setDireccion] = useState("");
    const [alias, setAlias] = useState("");
    const [phone, setPhone] = useState("");
    const [direccionDetalle, setDireccionDetalle] = useState("");
    const [dateBirth, setDateBirth] = useState("");
    const [update, setUpdate] = useState(false);
    const [showPDF, setShowPDF] = useState(false);
    const [pdfbase64, setPdfbase64] = useState("");
    const [clientId, setClientId] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showCreateAval, setShowCreateAval] = useState(false);

    const [stateSelect, setStateSelect] = useState(null);
    const [municipalFilter, setMunicipalFilter] = useState([]);
    const [municipalSelect, setMunicipalSelect] = useState(null);

    const [postalCodeFilter, setPostalCodeFilter] = useState([]);
    const [postalCodeSelect, setPostalCodeSelect] = useState(null);

    const [oficesFilter, setOficesFilter] = useState([]);
    const [oficesSelect, setOficesSelect] = useState(null);

    const [coordinadorFilter, setCoordinadorFilter] = useState([]);
    const [coordinadorSelect, setCoordinadorSelect] = useState(null);
    const [asesorSelect, setAsesorSelect] = useState(null);
    const [addressTypeSelect, setAddressTypeSelect] = useState(null);

    const [maritalEstatusSelect, setMaritalEstatusSelect] = useState(null);
    const [gendersSelect, setGendersSelect] = useState(null);

    const [stateSelectFam, setStateSelectFam] = useState(null);
    const [municipalSelectFam, setMunicipalSelectFam] = useState(null);
    const [postalCodeSelectFam, setPostalCodeSelectFam] = useState(null);

    const [stateSelectPer, setStateSelectPer] = useState(null);
    const [municipalSelectPer, setMunicipalSelectPer] = useState(null);
    const [postalCodeSelectPer, setPostalCodeSelectPer] = useState(null);

    const [stateSelectNeg, setStateSelectNeg] = useState(null);
    const [municipalSelectNeg, setMunicipalSelectNeg] = useState(null);
    const [postalCodeSelectNeg, setPostalCodeSelectNeg] = useState(null);

    const [stateSelectAval, setStateSelectAval] = useState(null);
    const [municipalSelectAval, setMunicipalSelectAval] = useState(null);
    const [postalCodeSelectAval, setPostalCodeSelectAval] = useState(null);
    const [gendersSelectAval, setGendersSelectAval] = useState(null);

    const [municipalFilterFam, setMunicipalFilterFam] = useState([]);
    const [postalCodeFilterFam, setPostalCodeFilterFam] = useState([]);
    const [municipalFilterPer, setMunicipalFilterPer] = useState([]);
    const [postalCodeFilterPer, setPostalCodeFilterPer] = useState([]);
    const [municipalFilterNeg, setMunicipalFilterNeg] = useState([]);
    const [postalCodeFilterNeg, setPostalCodeFilterNeg] = useState([]);
    const [municipalFilterAval, setMunicipalFilterAval] = useState([]);
    const [postalCodeFilterAval, setPostalCodeFilterAval] = useState([]);
    const [documentTypeClientSelect, setDocumentTypeClientSelect] = useState(null);
    const [documentsTypesClient, setDocumentsTypesClient] = useState([]);


    const [documentTypeAvalSelect, setDocumentTypeAvalSelect] = useState(null);
    const [documentsTypesAval, setDocumentsTypesAval] = useState([]);

    const [avalSelect, setAvalSelect] = useState(null);
    const [documents, setDocuments] = useState([]);

    const [avals, setAvals] = useState([]);

    const [dragActive, setDragActive] = useState(false);
    const [loadingStart, setLoadingStart] = useState(false);
    const [file, setFile] = useState([]);
    const [fileFront, setFileFront] = useState([]);
    const [fileFront2, setFileFront2] = useState([]);
    const inputRef = React.useRef(null);


    const [dragActiveGT, setDragActiveGT] = useState(false);
    const [fileGT, setFileGT] = useState([]);
    const [fileFrontGT, setFileFrontGT] = useState([]);
    const [fileFrontGT2, setFileFrontGT2] = useState([]);
    const inputRefGT = React.useRef(null);
    const [dragActiveCLT, setDragActiveCLT] = useState(false);
    const [fileCLT, setFileCLT] = useState([]);
    const [fileFrontCLT, setFileFrontCLT] = useState([]);
    const [fileFrontCLT2, setFileFrontCLT2] = useState([]);
    const inputRefCLT = React.useRef(null);

    const [dragActiveAval, setDragActiveAval] = useState(false);
    const [fileAval, setFileAval] = useState([]);
    const [fileFrontAval, setFileFrontAval] = useState([]);
    const [fileFrontAval2, setFileFrontAval2] = useState([]);

    const [idAvalSelect, setIdAvalSelect] = useState(0);
    const inputRefAval = React.useRef(null);



    const [menu01Data, setMenu01Data] = useState({
        name: "",
        primerApellido: "",
        segundoApellido: "",
        direccion: "",
        Noext: "",
        telefono: "",
        fechaNacimiento: "",
        edad: 0,
        lugarNacimiento: "",
        estadoCivil: "",
        sexo: "",
        escolaridad: "",
        CURP: "",
        NoCredencial: "",
        RFC: "",
        dependientes: "",
        antiguedad: "",
        nacionalidad: ""
    });
    const [menu02Data, setMenu02Data] = useState({
        spousesDataId: 0,
        name: "",
        primerApellido: "",
        segundoApellido: "",
        fechaNacimiento: "",
        edad: 0,
        ocupacion: "",
        empresa: "",
        ingreso: 0,
        phone: ""
    });
    const [menu03Data, setMenu03Data] = useState({
        addressVerificationId: 0,
        personas: "",
        vivienda: "",
        vialidad1: "",
        vialidad2: "",
    });
    const [menu04Data, setMenu04Data] = useState({
        fam_referenceId: 0,
        fam_names: "",
        fam_fathersLastName: "",
        fam_mothersLastName: "",
        fam_relationship: "",
        fam_addressDescription: "",
        fam_extIntNumber: "",
        fam_phoneNumber: "",
        per_referenceId: 0,
        per_names: "",
        per_fathersLastName: "",
        per_mothersLastName: "",
        per_relationship: "",
        per_addressDescription: "",
        per_extIntNumber: "",
        per_phoneNumber: "",
        neg_referenceId: 0,
        neg_businessName: "",
        neg_businessActivity: "",
        neg_antiquityOfTheBusiness: "",
        neg_federalTaxpayerRegistry: "",
        neg_monthlyIncome: "",
        neg_addressDescription: "",
        neg_extIntNumber: "",
        neg_phoneNumber: ""

    });
    const [menu05Data, setMenu05Data] = useState({
        warrantyId: 0,
        descriptionWar: "",
        questionId01: 0,
        answerBool01: false,
        answerString01: "",
        questionId02: 0,
        answerBool02: false,
        answerString02: "",
    });
    const [menu06Data, setMenu06Data] = useState({
        idBacking: 0,
        names: "",
        fathersLastName: "",
        mothersLastName: "",
        dateOfBirth: "",
        credentialNumber: "",
        populationRegistrationCode: "",
        addressDescription: "",
        phoneNumber: "",
        addressReferences: ""
    });


    const [menuActive, setMenuActive] = useState("menu01");

    const [active, setActive] = useState(true);
    const handleAgregarPersonalData = () => {
        let payload = {
            names: menu01Data.name,
            fathersLastName: menu01Data.primerApellido,
            mothersLastName: menu01Data.segundoApellido,
            stateId: stateSelect.value,
            municipalityId: municipalSelect.value,
            postalCodeId: postalCodeSelect.value,
            address: menu01Data.direccion,
            extIntNumber: menu01Data.Noext,
            phoneNumber: menu01Data.telefono,
            dateOfBirth: menu01Data.fechaNacimiento,
            placeOfBirth: menu01Data.lugarNacimiento,
            maritalStatusId: maritalEstatusSelect!=null?maritalEstatusSelect.value:null,
            genderId: gendersSelect!=null?gendersSelect.value:null,
            education: menu01Data.escolaridad,
            populationRegistrationCode: menu01Data.CURP,
            credentialNumber: menu01Data.NoCredencial,
            federalTaxpayerRegistry: menu01Data.RFC,
            economicDependents: menu01Data.dependientes,
            nationality: menu01Data.nacionalidad,
            status: active,
            advisorId: asesorSelect.value,
            lengthResidence: menu01Data.antiguedad
        }
        api("/Distributors"+SERVICE.setPersonal, payload, "POST")
            .then((data) => {
                let response = data.data;
                setClientId(response.data);
                setMenuActive("menu02")
                if (response.status) {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Guardado correctamente",
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
                else {
                    Swal.fire({
                        title: response.generalMessage,
                        icon: 'error',
                        confirmButtonText: 'Aceptar'
                    })
                }

            })
            .catch((err) => {
                console.log(err);
            })

    }
    const handleCreateAval = () => {
        let payload = {
            names: menu06Data.names,
            fathersLastName: menu06Data.fathersLastName,
            mothersLastName: menu06Data.mothersLastName,
            dateOfBirth: menu06Data.dateOfBirth,
            genderId: gendersSelectAval.value,
            stateId: stateSelectAval.value,
            municipalityId: municipalSelectAval.value,
            postalCodeId: postalCodeSelectAval.value,
            credentialNumber: menu06Data.credentialNumber,
            populationRegistrationCode: menu06Data.populationRegistrationCode,
            addressDescription: menu06Data.addressDescription,
            phoneNumber: menu06Data.phoneNumber,
            addressReferences: menu06Data.addressReferences
        }
        api(SERVICE.setAval, payload, "POST")
            .then((data) => {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Aval Guardado correctamente",
                    showConfirmButton: false,
                    timer: 1500
                });
                setMenu06Data({
                    idBacking: 0,
                    names: "",
                    fathersLastName: "",
                    mothersLastName: "",
                    dateOfBirth: "",
                    credentialNumber: "",
                    populationRegistrationCode: "",
                    addressDescription: "",
                    phoneNumber: "",
                    addressReferences: ""
                });
                setStateSelectAval(null);
                setMunicipalSelectAval(null);
                setGendersSelectAval(null);
                setPostalCodeSelectAval(null);
                setShowCreateAval(false);
                handleGetAval();

            })
            .catch((err) => {
                console.log(err);

            })

    }

    const handleChangeState = (type, valueSelect, updateActual = true) => {
        if (valueSelect != null && codigos && codigos.length > 0) {
            if (updateActual) {
                if (type === "MAIN") {
                    setMunicipalSelect(null);
                    setPostalCodeSelect(null);
                }
                else if (type === "FAM") {
                    setMunicipalSelectFam(null);
                    setPostalCodeSelectFam(null);
                }
                else if (type === "PER") {
                    setMunicipalSelectPer(null);
                    setPostalCodeSelectPer(null);
                }
                else if (type === "NEG") {
                    setMunicipalSelectNeg(null);
                    setPostalCodeSelectNeg(null);
                }
                else if (type === "AVAL") {
                    setMunicipalSelectAval(null);
                    setPostalCodeSelectAval(null);
                }
            }

            let ArrayTemp = [];
            for (let index = 0; index < municipios.length; index++) {
                const element = municipios[index];
                if (element.stateId === valueSelect.value) {
                    ArrayTemp.push(element);
                }
            }
            if (type === "MAIN") {
                setStateSelect(valueSelect);
                setMunicipalFilter(ArrayTemp);
            }
            else if (type === "FAM") {
                setStateSelectFam(valueSelect);
                setMunicipalFilterFam(ArrayTemp);
            }
            else if (type === "PER") {
                setStateSelectPer(valueSelect);
                setMunicipalFilterPer(ArrayTemp);
            }
            else if (type === "NEG") {
                setStateSelectNeg(valueSelect);
                setMunicipalFilterNeg(ArrayTemp);
            }
            else if (type === "AVAL") {
                setStateSelectAval(valueSelect);
                setMunicipalFilterAval(ArrayTemp);
            }
        }
    }
    const handleChangeMunicipal = (type, valueSelect, updateActual = true) => {
        if (valueSelect != null && municipios && municipios.length > 0) {
            if (updateActual) {
                if (type === "MAIN") {
                    setPostalCodeSelect(null);
                }
                else if (type === "FAM") {
                    setPostalCodeSelectFam(null);
                }
                else if (type === "PER") {
                    setPostalCodeSelectPer(null);
                }
                else if (type === "NEG") {
                    setPostalCodeSelectNeg(null);
                }
                else if (type === "AVAL") {
                    setPostalCodeSelectAval(null);
                }
            }
            let ArrayTemp = [];
            for (let index = 0; index < codigos.length; index++) {
                const element = codigos[index];
                if (element.municipalityId === valueSelect.value) {
                    ArrayTemp.push(element);
                }
            }
            if (type === "MAIN") {
                setMunicipalSelect(valueSelect);
                setPostalCodeFilter(ArrayTemp);
            }
            else if (type === "FAM") {
                setMunicipalSelectFam(valueSelect);
                setPostalCodeFilterFam(ArrayTemp);
            }
            else if (type === "PER") {
                setMunicipalSelectPer(valueSelect);
                setPostalCodeFilterPer(ArrayTemp);
            }
            else if (type === "NEG") {
                setMunicipalSelectNeg(valueSelect);
                setPostalCodeFilterNeg(ArrayTemp);
            }
            else if (type === "AVAL") {
                setMunicipalSelectAval(valueSelect);
                setPostalCodeFilterAval(ArrayTemp);
            }
        }
    }
    const handleGetAval = async () => {
        await api(SERVICE.getAval)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    let dataFull = data.data.data;
                    for (let index = 0; index < dataFull.length; index++) {
                        const element = dataFull[index];
                        arrayTemp.push({
                            ...element,
                            value: element.id,
                            label: element.populationRegistrationCode + " - " + element.fathersLastName + " " + element.mothersLastName + " " + element.names
                        });
                    }
                    setAvals(arrayTemp);
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const handleAgregar = async () => {
        if (menu01Data.name === "" || menu01Data.primerApellido === "" || menu01Data.segundoApellido === "" || menu01Data.direccion === "" || menu01Data.Noext === "" || menu01Data.telefono === "" || stateSelect === null || municipalSelect === null || postalCodeSelect === null || clientId == 0) {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            let payload = {
                id: clientId,
                names: menu01Data.name,
                fathersLastName: menu01Data.primerApellido,
                mothersLastName: menu01Data.segundoApellido,
                stateId: stateSelect.value,
                municipalityId: municipalSelect.value,
                postalCodeId: postalCodeSelect.value,
                address: menu01Data.direccion,
                extIntNumber: menu01Data.Noext,
                phoneNumber: menu01Data.telefono,
                dateOfBirth: menu01Data.fechaNacimiento,
                placeOfBirth: menu01Data.lugarNacimiento,
                maritalStatusId: maritalEstatusSelect.value,
                genderId: gendersSelect.value,
                education: menu01Data.escolaridad,
                populationRegistrationCode: menu01Data.CURP,
                credentialNumber: menu01Data.NoCredencial,
                federalTaxpayerRegistry: menu01Data.RFC,
                economicDependents: menu01Data.dependientes,
                nationality: menu01Data.nacionalidad,
                status: active,
                advisorId: asesorSelect.value,
                lengthResidence: menu01Data.antiguedad
            }
            await api("/Distributors"+SERVICE.updatePersonal, payload, "PUT")
                .then((data) => {
                    let response = data.data;
                    if (response.status) {
                        
                    }

                })
                .catch((err) => {
                    console.log(err);
                })

        }
        if (menu02Data.name != "") {
            let payload = {
                id: menu02Data.spousesDataId,
                clientId: clientId,
                names: menu02Data.name,
                fathersLastName: menu02Data.primerApellido,
                mothersLastName: menu02Data.segundoApellido,
                dateOfBirth: menu02Data.fechaNacimiento,
                phoneNumber: menu02Data.phone,
                occupation: menu02Data.ocupacion,
                companyName: menu02Data.empresa,
                monthlyIncome: menu02Data.ingreso
            }
            let URL = menu02Data.spousesDataId != 0 ? SERVICE.updateConyuge : SERVICE.setConyuge;
            let METHOD = menu02Data.spousesDataId != 0 ? "PUT" : "POST";
            await api("/Distributors"+URL, payload, METHOD)
                .then((data) => {
                    let response = data.data;
                    if (response.status) {
                        
                    }

                })
                .catch((err) => {
                    console.log(err);
                })
        }
        if (addressTypeSelect != null && menu03Data.personas !== "") {
            let payload = {
                id: menu03Data.addressVerificationId,
                clientId: clientId,
                addressTypeId: addressTypeSelect.value,
                numberOfPeople: menu03Data.personas,
                houseDescription: menu03Data.vivienda,
                betweenStreetOne: menu03Data.vialidad1,
                betweenStreetTwo: menu03Data.vialidad2,
            }
            let URL = menu03Data.addressVerificationId != 0 ? SERVICE.updateVerificacionDom : SERVICE.setVerificacionDom;
            let METHOD = menu03Data.addressVerificationId != 0 ? "PUT" : "POST";
            await api("/Distributors"+URL, payload, METHOD)
                .then((data) => {
                    let response = data.data;
                    if (response.status) {

                    }

                })
                .catch((err) => {
                    console.log(err);
                })
        }
        if (file.length > 0) {
            let search = documentTypes.findIndex(item => item.identifier === "VERDOM");
            if (search !== -1) {
                let documentTypeId = documentTypes[search].id;


                let payload = new FormData();

                // Agregar todos los archivos al FormData
                for (let index = 0; index < file.length; index++) {
                    payload.append('File', file[index]); // 'Files' debe coincidir con el nombre esperado en el backend
                }

                // Agregar los otros parámetros (solo una vez)
                payload.append('documentTypeId', documentTypeId);
                payload.append('elementId', clientId);
                payload.append('area', "CLT");

                // Hacer una sola llamada API
                await api(SERVICE.uploadDocuments, payload, "POST")
                    .then((data) => {
                        let response = data.data;
                        if (response.status) {
                           
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });

            }
        }
        if (menu04Data.fam_names !== "") {
            let search = referenceTypes.findIndex(item => item.identifier === "FAM");
            if (search !== -1) {
                let clientReferenceTypeId = referenceTypes[search].id;
                let payload = {
                    id: menu04Data.fam_referenceId,
                    clientId: clientId,
                    referenceTypeId: clientReferenceTypeId,
                    names: menu04Data.fam_names,
                    fathersLastName: menu04Data.fam_fathersLastName,
                    mothersLastName: menu04Data.fam_mothersLastName,
                    relationship: menu04Data.fam_relationship,
                    stateId: stateSelectFam != null ? stateSelectFam.value : 0,
                    municipalityId: municipalSelectFam != null ? municipalSelectFam.value : 0,
                    postalCodeId: postalCodeSelectFam != null ? postalCodeSelectFam.value : 0,
                    addressDescription: menu04Data.fam_addressDescription,
                    extIntNumber: menu04Data.fam_extIntNumber,
                    phoneNumber: menu04Data.fam_phoneNumber,
                }
                let URL = menu04Data.fam_referenceId != 0 ? SERVICE.updateReference : SERVICE.setReference;
                let METHOD = menu04Data.fam_referenceId != 0 ? "PUT" : "POST";
                await api("/Distributors"+URL, payload, METHOD)
                    .then((data) => {
                        let response = data.data;
                        if (response.status) {
                        }

                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }

        }
        if (menu04Data.per_names !== "") {
            let search = referenceTypes.findIndex(item => item.identifier === "PER");
            if (search !== -1) {
                let clientReferenceTypeId = referenceTypes[search].id;
                let payload = {
                    id: menu04Data.per_referenceId,
                    clientId: clientId,
                    referenceTypeId: clientReferenceTypeId,
                    names: menu04Data.per_names,
                    fathersLastName: menu04Data.per_fathersLastName,
                    mothersLastName: menu04Data.per_mothersLastName,
                    relationship: menu04Data.per_relationship,
                    stateId: stateSelectPer != null ? stateSelectPer.value : 0,
                    municipalityId: municipalSelectPer != null ? municipalSelectPer.value : 0,
                    postalCodeId: postalCodeSelectPer != null ? postalCodeSelectPer.value : 0,
                    addressDescription: menu04Data.per_addressDescription,
                    extIntNumber: menu04Data.per_extIntNumber,
                    phoneNumber: menu04Data.per_phoneNumber,
                }
                let URL = menu04Data.per_referenceId != 0 ? SERVICE.updateReference : SERVICE.setReference;
                let METHOD = menu04Data.per_referenceId != 0 ? "PUT" : "POST";
                await api("/Distributors"+URL, payload, METHOD)
                    .then((data) => {
                        let response = data.data;
                        if (response.status) {
                        }

                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }

        }
        if (menu04Data.neg_businessName !== "") {
            let payload = {
                id: menu04Data.neg_referenceId,
                clientId: clientId,
                businessName: menu04Data.neg_businessName,
                businessActivity: menu04Data.neg_businessActivity,
                antiquityOfTheBusiness: menu04Data.neg_antiquityOfTheBusiness,
                federalTaxpayerRegistry: menu04Data.neg_federalTaxpayerRegistry,
                monthlyIncome: menu04Data.neg_monthlyIncome,
                stateId: stateSelectNeg != null ? stateSelectNeg.value : 0,
                municipalityId: municipalSelectNeg != null ? municipalSelectNeg.value : 0,
                postalCodeId: postalCodeSelectNeg != null ? postalCodeSelectNeg.value : 0,
                addressDescription: menu04Data.neg_addressDescription,
                extIntNumber: menu04Data.neg_extIntNumber,
                phoneNumber: menu04Data.neg_phoneNumber
            }
            let URL = menu04Data.neg_referenceId != 0 ? SERVICE.updateBussinessData : SERVICE.setBussinessData;
            let METHOD = menu04Data.neg_referenceId != 0 ? "PUT" : "POST";
            await api("/Distributors"+URL, payload, METHOD)
                .then((data) => {
                    let response = data.data;
                    if (response.status) {
                    }

                })
                .catch((err) => {
                    console.log(err);
                })
        }
        if (fileGT.length > 0) {
            let search = documentTypes.findIndex(item => item.identifier === "GARAN");
            if (search !== -1) {
                let documentTypeId = documentTypes[search].id;


                let payload = new FormData();

                // Agregar todos los archivos al FormData
                for (let index = 0; index < fileGT.length; index++) {
                    payload.append('File', fileGT[index]); // 'Files' debe coincidir con el nombre esperado en el backend
                }

                // Agregar los otros parámetros (solo una vez)
                payload.append('documentTypeId', documentTypeId);
                payload.append('elementId', clientId);
                payload.append('area', "CLT");

                // Hacer una sola llamada API
                await api(SERVICE.uploadDocuments, payload, "POST")
                    .then((data) => {
                        let response = data.data;
                        if (response.status) {
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });

            }
        }
        if (fileCLT.length > 0) {
            let documentsRelate = ["INE", "CURP", "ACTNAC", "COMPDOM"];
            for (let index2 = 0; index2 < documentsRelate.length; index2++) {
                const identifierActual = documentsRelate[index2];
                let filterItems = fileCLT.filter(item => item.name.toLowerCase().includes(identifierActual.toLowerCase()));
                if (filterItems.length > 0) {
                    let search = documentTypes.findIndex(item => item.identifier === identifierActual && item.type === "CLIENTE");
                    if (search !== -1) {
                        let documentTypeId = documentTypes[search].id;
                        let payload = new FormData();
                        for (let index = 0; index < filterItems.length; index++) {
                            payload.append('File', filterItems[index]);
                        }
                        payload.append('documentTypeId', documentTypeId);
                        payload.append('elementId', clientId);
                        payload.append('area', "CLT");
                        await api(SERVICE.uploadDocuments, payload, "POST").then((data) => { }).catch((err) => { });
                    }
                }
            }
        }
        if (fileAval.length > 0) {
            let documentsRelate = ["INE", "CURP", "ACTNAC", "COMPDOM"];
            for (let index2 = 0; index2 < documentsRelate.length; index2++) {
                const identifierActual = documentsRelate[index2];
                let filterItems = fileAval.filter(item => item.name.toLowerCase().includes(identifierActual.toLowerCase()));
                if (filterItems.length > 0) {
                    let search = documentTypes.findIndex(item => item.identifier === identifierActual && item.type === "AVAL");
                    if (search !== -1) {
                        let documentTypeId = documentTypes[search].id;
                        let payload = new FormData();
                        for (let index = 0; index < filterItems.length; index++) {
                            payload.append('File', filterItems[index]);
                        }
                        payload.append('documentTypeId', documentTypeId);
                        payload.append('elementId', clientId);
                        payload.append('area', "CLT");
                        await api(SERVICE.uploadDocuments, payload, "POST").then((data) => { }).catch((err) => { });
                    }
                }
            }
        }
        if (menu05Data.descriptionWar != "") {
            let payload = {
                id: menu05Data.warrantyId,
                clientId: clientId,
                description: menu05Data.descriptionWar
            }
            let URL = menu05Data.warrantyId != 0 ? SERVICE.updateWarranty : SERVICE.setWarranty;
            let METHOD = menu05Data.warrantyId != 0 ? "PUT" : "POST";
            await api("/Distributors"+URL, payload, METHOD)
                .then((data) => {
                    let response = data.data;
                    if (response.status) {

                    }

                })
                .catch((err) => {
                    console.log(err);
                })
        }
        if (menu05Data.answerBool01) {
            let payload = {
                id: menu05Data.questionId01,
                questionId: questions && questions.length > 0 ? questions[0].id : 0,
                clientId: clientId,
                answerBool: menu05Data.answerBool01,
                answerString: menu05Data.answerString01
            }
            let URL = menu05Data.questionId01 != 0 ? SERVICE.updatePoliticallyExposedQuestions : SERVICE.setPoliticallyExposedQuestions;
            let METHOD = menu05Data.questionId01 != 0 ? "PUT" : "POST";
            await api("/Distributors"+URL, payload, METHOD)
                .then((data) => {
                    let response = data.data;
                    if (response.status) {

                    }
                    else {
                        Swal.fire({
                            title: response.generalMessage,
                            icon: 'error',
                            confirmButtonText: 'Aceptar'
                        })
                    }

                })
                .catch((err) => {
                    console.log(err);
                })
        }
        if (menu05Data.answerBool02) {
            let payload = {
                id: menu05Data.questionId02,
                questionId: questions && questions.length > 1 ? questions[1].id : 0,
                clientId: clientId,
                answerBool: menu05Data.answerBool02,
                answerString: menu05Data.answerString02
            }
            let URL = menu05Data.questionId02 != 0 ? SERVICE.updatePoliticallyExposedQuestions : SERVICE.setPoliticallyExposedQuestions;
            let METHOD = menu05Data.questionId02 != 0 ? "PUT" : "POST";
            await api("/Distributors"+URL, payload, METHOD)
                .then((data) => {
                    let response = data.data;
                    if (response.status) {
                    }

                })
                .catch((err) => {
                    console.log(err);
                })
        }
        if (avalSelect != null) {
            let payload = {
                id: idAvalSelect,
                backingId: avalSelect.value,
                clientId: clientId,
            }
            let URL = idAvalSelect != 0 ? SERVICE.updateAvalClient : SERVICE.setAvalClient;
            let METHOD = idAvalSelect != 0 ? "PUT" : "POST";
            await api("/Distributors"+URL, payload, METHOD)
                .then((data) => {
                    let response = data.data;
                    if (response.status) {
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }
        setShow(false);
        Swal.fire({
            position: "center",
            icon: "success",
            text: "Datos guardados correctamente",
            showConfirmButton: false,
            timer: 2000
        });

    }

    const onButtonClick = () => {
        inputRef.current.click();
    };
    const handleDrag = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };
    const handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            //drag
            const fileTemp = e.dataTransfer.files;
            for (let index = 0; index < fileTemp.length; index++) {
                const element = fileTemp[index];
                const searchFile = file.findIndex(file => file.name === element.name);
                if (searchFile === -1) {
                    setFile(oldArray => [...oldArray, element]);
                }
                else {
                    //toast.error('El archivo: ' + element.name + " ya fue agregado", APP_OPTIONS.TOAST_OPTIONS);
                }
            }
        }
    };

    const handleDeleteItem = (name) => {
        setFile(oldArray => [...oldArray.filter(file => file.name != name)]);
    }
    const handleChange = function (e) {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            const fileTemp = e.target.files;
            for (let index = 0; index < fileTemp.length; index++) {
                const element = fileTemp[index];
                const searchFile = file.findIndex(file => file.name === element.name);
                if (searchFile === -1) {
                    setFile(oldArray => [...oldArray, element]);
                }
                else {
                    // toast.error('El archivo: ' + element.name + " ya fue agregado", {
                    //     position: "bottom-right",
                    //     autoClose: 5000,
                    //     theme: "colored",
                    // });
                }
            }
        }
    };
    const onButtonClickGT = () => {
        inputRefGT.current.click();
    };
    const handleDragGT = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActiveGT(true);
        } else if (e.type === "dragleave") {
            setDragActiveGT(false);
        }
    };
    const handleDropGT = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActiveGT(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            //drag
            const fileTemp = e.dataTransfer.files;
            for (let index = 0; index < fileTemp.length; index++) {
                const element = fileTemp[index];
                const searchFile = fileGT.findIndex(file => file.name === element.name);
                if (searchFile === -1) {
                    setFileGT(oldArray => [...oldArray, element]);
                }
                else {
                    //toast.error('El archivo: ' + element.name + " ya fue agregado", APP_OPTIONS.TOAST_OPTIONS);
                }
            }
        }
    };

    const handleDeleteItemGT = (name) => {
        setFileGT(oldArray => [...oldArray.filter(file => file.name != name)]);
    }
    const handleChangeGT = function (e) {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            const fileTemp = e.target.files;
            for (let index = 0; index < fileTemp.length; index++) {
                const element = fileTemp[index];
                const searchFile = fileGT.findIndex(file => file.name === element.name);
                if (searchFile === -1) {
                    setFileGT(oldArray => [...oldArray, element]);
                }
                else {
                    // toast.error('El archivo: ' + element.name + " ya fue agregado", {
                    //     position: "bottom-right",
                    //     autoClose: 5000,
                    //     theme: "colored",
                    // });
                }
            }
        }
    };
    const onButtonClickCLT = () => {
        inputRefCLT.current.click();
    };
    const handleDragCLT = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActiveCLT(true);
        } else if (e.type === "dragleave") {
            setDragActiveCLT(false);
        }
    };

    const generarLlaveUnica = () => {
        const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let resultado = '';

        // Array para almacenar valores criptográficos
        const valores = new Uint32Array(6);
        crypto.getRandomValues(valores);

        for (let i = 0; i < 6; i++) {
            resultado += caracteres[valores[i] % caracteres.length];
        }

        return resultado;
    };
    const handleDropCLT = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActiveCLT(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            //drag
            const fileTemp = e.dataTransfer.files;
            for (let index = 0; index < fileTemp.length; index++) {
                const element = fileTemp[index];

                const renamedFile = new File([element], `${documentTypeClientSelect.identifier}${generarLlaveUnica()}${clientId}${element.name.substring(element.name.lastIndexOf('.'))}`, {
                    type: element.type,
                    lastModified: element.lastModified
                });
                const searchFile = fileCLT.findIndex(file => file.name === renamedFile.name);
                if (searchFile === -1) {
                    setFileCLT(oldArray => [...oldArray, renamedFile]);
                }
                else {
                    //toast.error('El archivo: ' + element.name + " ya fue agregado", APP_OPTIONS.TOAST_OPTIONS);
                }
            }
        }
    };
    useEffect(() => {
        console.log("avals", avals)
    }, [avals])
    const handleDeleteItemCLT = (name) => {
        setFileCLT(oldArray => [...oldArray.filter(file => file.name != name)]);
    }
    const handleChangeCLT = function (e) {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            const fileTemp = e.target.files;
            for (let index = 0; index < fileTemp.length; index++) {
                const element = fileTemp[index];
                const renamedFile = new File([element], `${documentTypeClientSelect.identifier}${generarLlaveUnica()}${clientId}${element.name.substring(element.name.lastIndexOf('.'))}`, {
                    type: element.type,
                    lastModified: element.lastModified
                });
                const searchFile = fileCLT.findIndex(file => file.name === renamedFile.name);
                if (searchFile === -1) {
                    setFileCLT(oldArray => [...oldArray, renamedFile]);
                }
                else {
                    //toast.error('El archivo: ' + element.name + " ya fue agregado", APP_OPTIONS.TOAST_OPTIONS);
                }
            }
        }
    };
    const onButtonClickAval = () => {
        inputRefAval.current.click();
    };
    const handleDragAval = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActiveAval(true);
        } else if (e.type === "dragleave") {
            setDragActiveAval(false);
        }
    };
    const handleDropAval = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActiveAval(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            //drag
            const fileTemp = e.dataTransfer.files;
            for (let index = 0; index < fileTemp.length; index++) {
                const element = fileTemp[index];

                const renamedFile = new File([element], `${documentTypeAvalSelect.identifier}${generarLlaveUnica()}${clientId}${element.name.substring(element.name.lastIndexOf('.'))}`, {
                    type: element.type,
                    lastModified: element.lastModified
                });
                const searchFile = fileAval.findIndex(file => file.name === renamedFile.name);
                if (searchFile === -1) {
                    setFileAval(oldArray => [...oldArray, renamedFile]);
                }
                else {
                    //toast.error('El archivo: ' + element.name + " ya fue agregado", APP_OPTIONS.TOAST_OPTIONS);
                }
            }
        }
    };
    const handleDeleteItemAval = (name) => {
        setFileAval(oldArray => [...oldArray.filter(file => file.name != name)]);
    }
    const handleChangeAval = function (e) {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            const fileTemp = e.target.files;
            for (let index = 0; index < fileTemp.length; index++) {
                const element = fileTemp[index];
                const renamedFile = new File([element], `${documentTypeAvalSelect.identifier}${generarLlaveUnica()}${clientId}${element.name.substring(element.name.lastIndexOf('.'))}`, {
                    type: element.type,
                    lastModified: element.lastModified
                });
                const searchFile = fileAval.findIndex(file => file.name === renamedFile.name);
                if (searchFile === -1) {
                    setFileAval(oldArray => [...oldArray, renamedFile]);
                }
                else {
                    //toast.error('El archivo: ' + element.name + " ya fue agregado", APP_OPTIONS.TOAST_OPTIONS);
                }
            }
        }
    };
    const handleGetPersonalData = async (id) => {
        await api("/Distributors"+SERVICE.getPersonalById + `${id}`)
            .then((data) => {
                if (data.data.data) {
                    let element = data.data.data;
                    setActive(element.status);
                    let search = estados.findIndex(item => item.value == element.stateId);
                    if (search !== -1)
                        handleChangeState("MAIN", estados[search], false);
                    search = municipios.findIndex(item => item.value == element.municipalityId);
                    if (search !== -1)
                        handleChangeMunicipal("MAIN", municipios[search], false);
                    search = codigos.findIndex(item => item.value == element.postalCodeId);
                    if (search !== -1)
                        setPostalCodeSelect(codigos[search]);
                    search = asesores.findIndex(item => item.value == element.advisorId);
                    if (search !== -1)
                        setAsesorSelect(asesores[search]);
                    search = maritalEstatus.findIndex(item => item.value == element.maritalStatusId);
                    if (search !== -1)
                        setMaritalEstatusSelect(maritalEstatus[search]);
                    search = genders.findIndex(item => item.value == element.genderId);
                    if (search !== -1)
                        setGendersSelect(genders[search]);
                    setMenu01Data({
                        name: element.names,
                        primerApellido: element.fathersLastName,
                        segundoApellido: element.mothersLastName,
                        direccion: element.address,
                        Noext: element.extIntNumber,
                        telefono: element.phoneNumber,
                        fechaNacimiento: element.dateOfBirth.split('T')[0],
                        edad: FUNTIONS.calculateAge(element.dateOfBirth),
                        lugarNacimiento: element.placeOfBirth,
                        escolaridad: element.education,
                        CURP: element.populationRegistrationCode,
                        NoCredencial: element.credentialNumber,
                        RFC: element.federalTaxpayerRegistry,
                        dependientes: element.economicDependents,
                        antiguedad: element.lengthResidence,
                        nacionalidad: element.nationality
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleConyugeData = async (id) => {
        await api("/Distributors"+SERVICE.getConyugeById + `${id}`)
            .then((data) => {
                if (data.data.data) {
                    let element = data.data.data
                    setMenu02Data({
                        spousesDataId: element.id,
                        name: element.names,
                        primerApellido: element.fathersLastName,
                        segundoApellido: element.mothersLastName,
                        fechaNacimiento: element.dateOfBirth.split("T")[0],
                        edad: FUNTIONS.calculateAge(element.dateOfBirth),
                        ocupacion: element.occupation,
                        empresa: element.companyName,
                        ingreso: element.monthlyIncome,
                        phone: element.phoneNumber,
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleVerificationDom = async (id) => {
        await api("/Distributors"+SERVICE.getVerificacionDomById + `${id}`)
            .then((data) => {
                if (data.data.data) {
                    let element = data.data.data;
                    let search = addressTypes.findIndex(item => item.value == element.addressTypeId);
                    if (search !== -1)
                        setAddressTypeSelect(addressTypes[search]);
                    setMenu03Data({
                        addressVerificationId: element.id,
                        personas: element.numberOfPeople,
                        vivienda: element.houseDescription,
                        vialidad1: element.betweenStreetOne,
                        vialidad2: element.betweenStreetTwo,
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleReference = async (id) => {
        await api("/Distributors"+SERVICE.getReferenceById + `${id}`)
            .then((data) => {
                if (data.data.data) {
                    let item = data.data.data;
                    for (let index = 0; index < item.length; index++) {
                        const element = item[index];

                        let searchRef = referenceTypes.findIndex(itm => itm.id === element.referenceTypeId)

                        if (searchRef != -1 && referenceTypes[searchRef].identifier === "FAM") {
                            let search = estados.findIndex(item => item.value == element.stateId);
                            if (search !== -1)
                                handleChangeState("FAM", estados[search], false);
                            search = municipios.findIndex(item => item.value == element.municipalityId);
                            if (search !== -1)
                                handleChangeMunicipal("FAM", municipios[search], false);
                            search = codigos.findIndex(item => item.value == element.postalCodeId);
                            if (search !== -1)
                                setPostalCodeSelectFam(codigos[search]);

                            setMenu04Data(prevState => ({
                                ...prevState,
                                fam_referenceId: element.id,
                                fam_names: element.names,
                                fam_fathersLastName: element.fathersLastName,
                                fam_mothersLastName: element.mothersLastName,
                                fam_relationship: element.relationship,
                                fam_addressDescription: element.addressDescription,
                                fam_extIntNumber: element.extIntNumber,
                                fam_phoneNumber: element.phoneNumber,
                            }));

                        }
                        else if (searchRef != -1 && referenceTypes[searchRef].identifier === "PER") {
                            let search = estados.findIndex(item => item.value == element.stateId);
                            if (search !== -1)
                                handleChangeState("PER", estados[search], false);
                            search = municipios.findIndex(item => item.value == element.municipalityId);
                            if (search !== -1)
                                handleChangeMunicipal("PER", municipios[search], false);
                            search = codigos.findIndex(item => item.value == element.postalCodeId);
                            if (search !== -1)
                                setPostalCodeSelectPer(codigos[search]);


                            setMenu04Data(prevState => ({
                                ...prevState,
                                per_referenceId: element.id,
                                per_names: element.names,
                                per_fathersLastName: element.fathersLastName,
                                per_mothersLastName: element.mothersLastName,
                                per_relationship: element.relationship,
                                per_addressDescription: element.addressDescription,
                                per_extIntNumber: element.extIntNumber,
                                per_phoneNumber: element.phoneNumber,
                            }));
                        }


                    }

                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleBussiness = async (id) => {
        await api("/Distributors"+SERVICE.getBussinessDataById + `${id}`)
            .then((data) => {
                if (data.data.data) {
                    let element = data.data.data;

                    let search = estados.findIndex(item => item.value == element.stateId);
                    if (search !== -1)
                        handleChangeState("NEG", estados[search], false);
                    search = municipios.findIndex(item => item.value == element.municipalityId);
                    if (search !== -1)
                        handleChangeMunicipal("NEG", municipios[search], false);
                    search = codigos.findIndex(item => item.value == element.postalCodeId);
                    if (search !== -1)
                        setPostalCodeSelectNeg(codigos[search]);

                    setMenu04Data(prevState => ({
                        ...prevState,
                        neg_referenceId: element.id,
                        neg_businessName: element.businessName,
                        neg_businessActivity: element.businessActivity,
                        neg_antiquityOfTheBusiness: element.antiquityOfTheBusiness,
                        neg_federalTaxpayerRegistry: element.federalTaxpayerRegistry,
                        neg_monthlyIncome: element.monthlyIncome,
                        neg_addressDescription: element.addressDescription,
                        neg_extIntNumber: element.extIntNumber,
                        neg_phoneNumber: element.phoneNumber,
                    }));
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleAvalClient = async (id) => {
        await api("/Distributors"+SERVICE.getAvalClient + `${id}`)
            .then((data) => {
                if (data.data.data) {
                    let element = data.data.data;
                    let search = avals.findIndex(item => item.value == element.backingId);
                    if(search!==-1){
                        setAvalSelect(avals[search]); 
                        setIdAvalSelect(element.id);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(()=>{
                setLoadingStart(false);
            })
    }
    const handleFiles = async (id) => {
        let arraytemp = [];
        await api(SERVICE.getDocumentsByClient + `${id}/By/CLIENTE`)
            .then((data) => {
                if (data.data.data) {
                    let array = data.data.data;
                    for (let index = 0; index < array.length; index++) {
                        const element = array[index];
                        arraytemp.push(element);
                    }

                }
            })
            .catch((err) => {
                console.log(err);
            })
        await api(SERVICE.getDocumentsByClient + `${id}/By/AVAL`)
            .then((data) => {
                if (data.data.data) {
                    let array = data.data.data;
                    for (let index = 0; index < array.length; index++) {
                        const element = array[index];
                        arraytemp.push(element);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            })
        setDocuments(arraytemp);
    }
    const handleQuestions = async (id) => {
        let respuesta = { ...menu05Data };
        await api("/Distributors"+SERVICE.getPoliticallyExposedQuestions + `${id}`)
            .then((data) => {
                if (data.data.data) {
                    let item = data.data.data;
                    for (let index = 0; index < item.length; index++) {
                        const element = item[index];
                        let questionId = questions && questions.length > 0 ? questions[0].id : 0
                        if (element.questionId == questionId) {
                            respuesta = {
                                ...respuesta,
                                questionId01: element.id,
                                answerBool01: element.answerBool,
                                answerString01: element.answerString
                            };
                        }
                        questionId = questions && questions.length > 1 ? questions[1].id : 0
                        if (element.questionId == questionId) {

                            respuesta = {
                                ...respuesta,
                                questionId02: element.id,
                                answerBool02: element.answerBool,
                                answerString02: element.answerString
                            };
                        }


                    }

                }
            })
            .catch((err) => {
                console.log(err);
            })
        await api("/Distributors"+SERVICE.getWarranty + `${id}`)
            .then((data) => {
                if (data.data.data) {
                    let element = data.data.data;


                    respuesta = {
                        ...respuesta,
                        warrantyId: element.id,
                        descriptionWar: element.description
                    };
                }
            })
            .catch((err) => {
                console.log(err);
            })

        setMenu05Data(respuesta);
    }
    const downloadPDF = (base64Data, fileName = 'documento.pdf') => {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }, 100);
    };
    const downloadImage = (imageBase64) => {
        const fileName = 'imagen.png';
        const link = document.createElement('a');
        link.href = imageBase64;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
    }
    const downloadPDFAsZip = async (type) => {
        try {
            const zip = new JSZip();
            let nameFolder = "DOCUMENTOS_" + type;
            const pdfFolder = zip.folder(nameFolder);

            const matchingPdfs = documents.filter(doc => doc.type === type && doc.identifier !== "GARAN" && doc.identifier !== "VERDOM");
            if (matchingPdfs.length === 0) {
                console.warn(`No se encontraron PDFs con el identificador`);
                return;
            }

            matchingPdfs.forEach((pdf, index) => {
                let text = "";
                if (pdf.identifier.includes("INE")) {
                    text = "CREDENCIAL_INE";
                }
                else if (pdf.identifier.includes("CURP")) {
                    text = "CURP"
                }
                else if (pdf.identifier.includes("ACTNAC")) {
                    text = "ACTA_NACIMIENTO"
                }
                else if (pdf.identifier.includes("COMPDOM")) {
                    text = "COMPROBANTE_DOMICILIO"
                }
                const base64Data = pdf.fileBase64;
                const cleanBase64 = base64Data.split(',')[1] || base64Data;

                const fileName = `${text}_ ${(index + 1).toString().padStart(2, '0')}.pdf`;

                pdfFolder.file(fileName, cleanBase64, { base64: true });
            });

            const content = await zip.generateAsync({
                type: 'blob',
                compression: 'DEFLATE',
                compressionOptions: { level: 6 }
            });

            saveAs(content, `${nameFolder}.zip`);

        } catch (error) {
            console.error('Error al generar el archivo ZIP:', error);
        }
    };
    const handleDeleteDocument = (id) => {
        Swal.fire({
            title: "¿Esta segur@ que desea eliminar este archivo?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            denyButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                api("/Distributors"+SERVICE.deleteDocuments + `?DocumentsId=${id}`, {}, "DELETE")
                    .then((data) => {
                        setDocuments(oldArray => [...oldArray.filter(file => file.id != id)]);
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        });

    }
    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.split(',')[1];
                resolve(base64String);
            };
            reader.onerror = (error) => reject(error);
        });
    };
    const downloadImagesAsZip = async (identifier) => {
        const zip = new JSZip();
        let nameFolder = identifier == "VERDOM" ? "verificacion_domicilio_images" : "garantia_images";
        const imgFolder = zip.folder(nameFolder);

        for (let index = 0; index < documents.length; index++) {
            const image = documents[index];
            if (image.identifier === identifier) {
                const base64Data = image.fileBase64;
                imgFolder.file((index < 9 ? "image0" : "image") + (index + 1) + ".png", base64Data, { base64: true });
            }

        }

        const content = await zip.generateAsync({ type: 'blob' });

        saveAs(content, nameFolder + '.zip');
    };
    useEffect(() => {
        if (file != null) {
            let arrayTemp = [];
            for (let index = 0; index < file.length; index++) {
                const element = file[index];
                const url = URL.createObjectURL(element);
                arrayTemp.push(
                    <div className={styles.imageList}>
                        {url && <Zoom><img src={url} alt="Preview" className={styles.imageItem} /></Zoom>}
                        <div className={styles.btnClose} onClick={() => { handleDeleteItem(element.name) }}><IoClose></IoClose></div>
                    </div>
                );
            }
            setFileFront(arrayTemp);
        }
    }, [file])
    useEffect(() => {
        if (fileGT != null) {
            let arrayTemp = [];
            for (let index = 0; index < fileGT.length; index++) {
                const element = fileGT[index];
                const url = URL.createObjectURL(element);
                arrayTemp.push(
                    <div className={styles.imageList}>
                        {url && <Zoom><img src={url} alt="Preview" className={styles.imageItem} /></Zoom>}
                        <div className={styles.btnClose} onClick={() => { handleDeleteItemGT(element.name) }}><IoClose></IoClose></div>
                    </div>
                );
            }
            setFileFrontGT(arrayTemp);
        }
    }, [fileGT])
    const obtenerFechaActual = () => {
        const fecha = new Date();

        const año = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses van de 0-11
        const dia = String(fecha.getDate()).padStart(2, '0');

        return `${año}-${mes}-${dia}`;
    };
    useEffect(() => {
        if (fileCLT != null) {
            let arrayTemp = [];
            for (let index = 0; index < fileCLT.length; index++) {
                const element = fileCLT[index];
                let text = "";
                if (element.name.includes("INE")) {
                    text = "CREDENCIAL (INE)"
                }
                else if (element.name.includes("CURP")) {
                    text = "CURP"
                }
                else if (element.name.includes("ACTNAC")) {
                    text = "ACTA DE NACIMIENTO"
                }
                else if (element.name.includes("COMPDOM")) {
                    text = "COMPROBANTE DE DOMICILIO"
                }
                arrayTemp.push(
                    <div>
                        <div className={styles.imageListCLT}>
                            <div onClick={async () => {
                                try {
                                    const base64 = await fileToBase64(element);
                                    setPdfbase64(base64);
                                    setShowPDF(true);
                                } catch (error) {
                                    console.error("Error al convertir el PDF:", error);
                                }
                            }} className={styles.containerPDF}><BsFileEarmarkPdfFill /></div>
                            <div className={styles.btnClose} onClick={() => { handleDeleteItemCLT(element.name) }}><IoClose></IoClose></div>
                        </div>
                        <div className={styles.txtCLT}>
                            {text}<br></br>{obtenerFechaActual()}
                        </div>
                    </div>
                );
            }
            setFileFrontCLT(arrayTemp);
        }
    }, [fileCLT])

    useEffect(() => {
        if (fileAval != null) {
            let arrayTemp = [];
            for (let index = 0; index < fileAval.length; index++) {
                const element = fileAval[index];
                let text = "";
                if (element.name.includes("INE")) {
                    text = "CREDENCIAL (INE)"
                }
                else if (element.name.includes("CURP")) {
                    text = "CURP"
                }
                else if (element.name.includes("ACTNAC")) {
                    text = "ACTA DE NACIMIENTO"
                }
                else if (element.name.includes("COMPDOM")) {
                    text = "COMPROBANTE DE DOMICILIO"
                }
                arrayTemp.push(
                    <div>
                        <div className={styles.imageListCLT}>
                            <div onClick={async () => {
                                try {
                                    const base64 = await fileToBase64(element);
                                    setPdfbase64(base64);
                                    setShowPDF(true);
                                } catch (error) {
                                    console.error("Error al convertir el PDF:", error);
                                }
                            }} className={styles.containerPDF}><BsFileEarmarkPdfFill /></div>
                            <div className={styles.btnClose} onClick={() => { handleDeleteItemAval(element.name) }}><IoClose></IoClose></div>
                        </div>
                        <div className={styles.txtCLT}>
                            {text}<br></br>{obtenerFechaActual()}
                        </div>
                    </div>
                );
            }
            setFileFrontAval(arrayTemp);
        }
    }, [fileAval])

    useEffect(() => {
        if (!show) {
            setMenu01Data({
                name: "",
                primerApellido: "",
                segundoApellido: "",
                direccion: "",
                Noext: "",
                telefono: "",
                fechaNacimiento: "",
                edad: 0,
                lugarNacimiento: "",
                estadoCivil: "",
                sexo: "",
                escolaridad: "",
                CURP: "",
                NoCredencial: "",
                RFC: "",
                dependientes: "",
                antiguedad: "",
                nacionalidad: ""
            });
            setMenu02Data({
                spousesDataId: 0,
                name: "",
                primerApellido: "",
                segundoApellido: "",
                fechaNacimiento: "",
                edad: 0,
                ocupacion: "",
                empresa: "",
                ingreso: 0,
                phone: ""
            });
            setMenu03Data({
                addressVerificationId: 0,
                personas: "",
                vivienda: "",
                vialidad1: "",
                vialidad2: "",
            });
            setMenu04Data({
                fam_referenceId: 0,
                fam_names: "",
                fam_fathersLastName: "",
                fam_mothersLastName: "",
                fam_relationship: "",
                fam_addressDescription: "",
                fam_extIntNumber: "",
                fam_phoneNumber: "",
                per_referenceId: 0,
                per_names: "",
                per_fathersLastName: "",
                per_mothersLastName: "",
                per_relationship: "",
                per_addressDescription: "",
                per_extIntNumber: "",
                per_phoneNumber: "",
                neg_referenceId: 0,
                neg_businessName: "",
                neg_businessActivity: "",
                neg_antiquityOfTheBusiness: "",
                neg_federalTaxpayerRegistry: "",
                neg_monthlyIncome: "",
                neg_addressDescription: "",
                neg_extIntNumber: "",
                neg_phoneNumber: ""

            });
            setMenu05Data({
                warrantyId: 0,
                descriptionWar: "",
                questionId01: 0,
                answerBool01: false,
                answerString01: "",
                questionId02: 0,
                answerBool02: false,
                answerString02: "",
            });
            setMenu06Data({
                idBacking: 0,
                names: "",
                fathersLastName: "",
                mothersLastName: "",
                dateOfBirth: "",
                credentialNumber: "",
                populationRegistrationCode: "",
                addressDescription: "",
                phoneNumber: "",
                addressReferences: ""
            });
            setStateSelectAval(null);
            setMunicipalSelectAval(null);
            setGendersSelectAval(null);
            setPostalCodeSelectAval(null);

            setAddressTypeSelect(null)
            setStateSelect(null);
            setMunicipalSelect(null);
            setPostalCodeSelect(null);
            setOficesSelect(null);
            setDataEdit(null);
            setCoordinadorSelect(null);
            setAsesorSelect(null);
            setGendersSelect(null);
            setMaritalEstatusSelect(null);
            setClientId(0);
            setMenuActive("menu01");
            setAvalSelect(null);
            setIdAvalSelect(0);
            setFile([]);
            setFileGT([]);
            setFileCLT([]);
            setFileAval([]);
        }
    }, [show])
    async function loadAllData(id) {
        try {
          await Promise.all([
            handleGetPersonalData(id),
            handleConyugeData(id),
            handleVerificationDom(id),
            handleReference(id),
            handleBussiness(id),
            handleQuestions(id),
            handleFiles(id),
            handleAvalClient(id)
          ]);
          
          setLoadingStart(false);
        } catch (error) {
          console.error("Error al cargar los datos:", error);
        }
      }
      
      // Luego llama a loadAllData() donde necesites
    useEffect(() => {
        if (dataEdit != null) {
            handleGetAval();
            setMenuActive("menu01");
            setUpdate(true);
            setLoading(true);
            setLoadingStart(true);
            setClientId(dataEdit.distributorId);
            loadAllData(dataEdit.distributorId);
            setLoading(false);
            setUpdate(false);
        }
    }, [dataEdit])
    useEffect(() => {
        if (documentTypes && documentTypes.length > 0) {
            let arrayTemp = [];
            let arrayTempAval = [];
            for (let index = 0; index < documentTypes.length; index++) {
                const element = documentTypes[index];
                if (element.type == "CLIENTE" && element.identifier !== "GARAN" && element.identifier !== "VERDOM") {
                    arrayTemp.push({
                        ...element,
                        label: element.description,
                        value: element.id
                    })
                }
                else if (element.type == "AVAL") {
                    arrayTempAval.push({
                        ...element,
                        label: element.description,
                        value: element.id
                    })
                }

            }
            setDocumentsTypesClient(arrayTemp);
            setDocumentsTypesAval(arrayTempAval);
            if (arrayTemp.length > 0) {
                setDocumentTypeClientSelect(arrayTemp[0]);
            }
            if (arrayTempAval.length > 0) {
                setDocumentTypeAvalSelect(arrayTempAval[0]);
            }
        }

    }, [documentTypes])
    useEffect(() => {
        if (menu01Data.fechaNacimiento != "") {
            setMenu01Data({ ...menu01Data, edad: FUNTIONS.calculateAge(menu01Data.fechaNacimiento) });
        }
    }, [menu01Data.fechaNacimiento])
    useEffect(() => {
        console.log("menu04Data", menu04Data)
    }, [menu04Data])
    useEffect(() => {
        if (documents.length > 0) {
            let array1 = [];
            let array2 = [];
            let array3 = [];
            let array4 = [];

            for (let index = 0; index < documents.length; index++) {
                const element = documents[index];
                const base64Image = `data:image/png;base64,${element.fileBase64}`;
                if (element.identifier == "VERDOM") {
                    array1.push(
                        <div className={styles.imageList}>
                            {base64Image && <Zoom><img src={base64Image} alt="Preview" className={styles.imageItem} /></Zoom>}
                            <div className={styles.containerBtnImage}>
                                <div className={styles.btnClose} onClick={() => { handleDeleteDocument(element.id) }}><IoClose></IoClose></div>
                                <div className={styles.btnClose2} onClick={() => { downloadImage(base64Image) }}><FaFileDownload></FaFileDownload></div>
                            </div>

                        </div>
                    );
                }
                else if (element.identifier == "GARAN") {
                    array2.push(
                        <div className={styles.imageList}>
                            {base64Image && <Zoom><img src={base64Image} alt="Preview" className={styles.imageItem} /></Zoom>}
                            <div className={styles.containerBtnImage}>
                                <div className={styles.btnClose} onClick={() => { handleDeleteDocument(element.id) }}><IoClose></IoClose></div>
                                <div className={styles.btnClose2} onClick={() => { downloadImage(base64Image) }}><FaFileDownload></FaFileDownload></div>
                            </div>

                        </div>
                    );
                }
                else if (element.type == "CLIENTE") {
                    let text = "";
                    if (element.identifier.includes("INE")) {
                        text = "CREDENCIAL (INE)"
                    }
                    else if (element.identifier.includes("CURP")) {
                        text = "CURP"
                    }
                    else if (element.identifier.includes("ACTNAC")) {
                        text = "ACTA DE NACIMIENTO"
                    }
                    else if (element.identifier.includes("COMPDOM")) {
                        text = "COMPROBANTE DE DOMICILIO"
                    }
                    array3.push(
                        <div>
                            <div className={styles.imageListCLT}>
                                <div onClick={() => {
                                    setPdfbase64(element.fileBase64);
                                    setShowPDF(true);
                                }} className={styles.containerPDF}><BsFileEarmarkPdfFill /></div>
                                <div className={styles.containerBtnImage}>
                                    <div className={styles.btnClose} onClick={() => { handleDeleteDocument(element.id) }}><IoClose></IoClose></div>
                                    <div className={styles.btnClose2} onClick={() => { downloadPDF(element.fileBase64, element.identifier + ".pdf") }}><FaFileDownload></FaFileDownload></div>
                                </div>
                            </div>
                            <div className={styles.txtCLT}>
                                {text}<br></br>{element.createdAt.split("T")[0]}
                            </div>
                        </div>
                    );
                }
                else if (element.type == "AVAL") {
                    let text = "";
                    if (element.identifier.includes("INE")) {
                        text = "CREDENCIAL (INE)"
                    }
                    else if (element.identifier.includes("CURP")) {
                        text = "CURP"
                    }
                    else if (element.identifier.includes("ACTNAC")) {
                        text = "ACTA DE NACIMIENTO"
                    }
                    else if (element.identifier.includes("COMPDOM")) {
                        text = "COMPROBANTE DE DOMICILIO"
                    }
                    array4.push(
                        <div>
                            <div className={styles.imageListCLT}>
                                <div onClick={() => {
                                    setPdfbase64(element.fileBase64);
                                    setShowPDF(true);
                                }} className={styles.containerPDF}><BsFileEarmarkPdfFill /></div>
                                <div className={styles.containerBtnImage}>
                                    <div className={styles.btnClose} onClick={() => { handleDeleteDocument(element.id) }}><IoClose></IoClose></div>
                                    <div className={styles.btnClose2} onClick={() => { downloadPDF(element.fileBase64, element.identifier + "_AVAL.pdf") }}><FaFileDownload></FaFileDownload></div>
                                </div>
                            </div>
                            <div className={styles.txtCLT}>
                                {text}<br></br>{element.createdAt.split("T")[0]}
                            </div>
                        </div>
                    );
                }
            }
            setFileFront2(array1);
            setFileFrontGT2(array2);
            setFileFrontCLT2(array3);
            setFileFrontAval2(array4);

        }
        else {
            setFileFront2([]);
            setFileFrontGT2([]);
            setFileFrontCLT2([]);
            setFileFrontAval2([]);
        }
    }, [documents])
    return (
        <>
            <div className={styles.bodyModal} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none" }}>
                    <div className={styles.headerForm}>
                        <h5>{dataEdit != null ? "Editar distribuidor" : "Nuevo distribuidor"}</h5>
                        <div disabled={loading} className={styles.icon} onClick={() => { if (!loading) setShow(false) }}>
                            <IoCloseSharp />
                        </div>

                    </div>
                    <div className={styles.containerTabs} style={{ display: loadingStart ? "none" : "" }}>
                        <ul class="nav nav-tabs">
                            <li className={menuActive == "menu01" ? "nav-item-active" : "nav-item"} onClick={() => setMenuActive("menu01")}>
                                <a className={menuActive == "menu01" ? "nav-link active" : "nav-link"}>Datos Personales</a>
                            </li>
                            <li className={menuActive == "menu02" ? "nav-item-active" : "nav-item"} onClick={() => { if (clientId != 0) setMenuActive("menu02"); }}>
                                <a className={clientId == 0 ? "nav-link disabled" : menuActive == "menu02" ? "nav-link active" : "nav-link"}>Datos Cónyuge</a>
                            </li>
                            <li className={menuActive == "menu03" ? "nav-item-active" : "nav-item"} onClick={() => { if (clientId != 0) setMenuActive("menu03"); }}>
                                <a className={clientId == 0 ? "nav-link disabled" : menuActive == "menu03" ? "nav-link active" : "nav-link"}>Verificación Dom.</a>
                            </li>
                            <li className={menuActive == "menu04" ? "nav-item-active" : "nav-item"} onClick={() => { if (clientId != 0) setMenuActive("menu04"); }}>
                                <a className={clientId == 0 ? "nav-link disabled" : menuActive == "menu04" ? "nav-link active" : "nav-link"}>Referencias</a>
                            </li>
                            <li className={menuActive == "menu05" ? "nav-item-active" : "nav-item"} onClick={() => { if (clientId != 0) setMenuActive("menu05"); }}>
                                <a className={clientId == 0 ? "nav-link disabled" : menuActive == "menu05" ? "nav-link active" : "nav-link"}>Garantía</a>
                            </li>
                            <li className={menuActive == "menu07" ? "nav-item-active" : "nav-item"} onClick={() => { if (clientId != 0) setMenuActive("menu07"); }}>
                                <a className={clientId == 0 ? "nav-link disabled" : menuActive == "menu07" ? "nav-link active" : "nav-link"}>Documentos</a>
                            </li>
                            <li className={menuActive == "menu06" ? "nav-item-active" : "nav-item"} onClick={() => { if (clientId != 0) setMenuActive("menu06"); }}>
                                <a className={clientId == 0 ? "nav-link disabled" : menuActive == "menu06" ? "nav-link active" : "nav-link"}>AVAL</a>
                            </li>

                        </ul>
                    </div>
                    <div className={styles.containerForm} style={{ display: loadingStart ? "flex" : "none" }}>
                        <div className={styles.containerLoading}>
                            <h1>Cargando datos...</h1>
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div className={styles.containerForm} style={{ display: menuActive == "menu01" && !loadingStart ? "flex" : "none" }}>

                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Nombre(s): *</label>
                            <input type="text" class="form-control" placeholder="Nombre" value={menu01Data.name} onChange={(e) => setMenu01Data({ ...menu01Data, name: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">A. Paterno: *</label>
                            <input type="text" class="form-control" placeholder="Alias" value={menu01Data.primerApellido} onChange={(e) => setMenu01Data({ ...menu01Data, primerApellido: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">A.Materno: *</label>
                            <input type="text" class="form-control" placeholder="Alias" value={menu01Data.segundoApellido} onChange={(e) => setMenu01Data({ ...menu01Data, segundoApellido: e.target.value })} />
                        </div>
                        {/* <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Sucursal: *</label>
                            <Select options={ofices} class="form-control" placeholder="Sucursal" value={oficesSelect} onChange={(e) => setOficesSelect(e)} />
                        </div> */}
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Estado: *</label>
                            <Select options={estados} class="form-control" placeholder="Estado" value={stateSelect} onChange={(e) => handleChangeState("MAIN", e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Municipio: *</label>
                            <Select options={municipalFilter} class="form-control" placeholder="Municipio" value={municipalSelect} onChange={(e) => handleChangeMunicipal("MAIN", e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Codigo Postal: *</label>
                            <Select options={postalCodeFilter} class="form-control" placeholder="Código Postal" value={postalCodeSelect} onChange={(e) => setPostalCodeSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Domicilio: *</label>
                            <input type="text" class="form-control" placeholder="Domicilio" value={menu01Data.direccion} onChange={(e) => setMenu01Data({ ...menu01Data, direccion: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">No Ext/Int: *</label>
                            <input type="text" class="form-control" placeholder="No Ext/Int" value={menu01Data.Noext} onChange={(e) => setMenu01Data({ ...menu01Data, Noext: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Número de telefono: *</label>
                            <input type="number" class="form-control" placeholder="1234567890" value={menu01Data.telefono} onChange={(e) => setMenu01Data({ ...menu01Data, telefono: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Asesor: *</label>
                            <Select options={asesores} class="form-control" placeholder="Asesor" value={asesorSelect} onChange={(e) => setAsesorSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Fecha de nacimiento: </label>
                            <input type="date" data-date-format="DD MMMM YYYY" class="form-control" placeholder="" value={menu01Data.fechaNacimiento} onChange={(e) => setMenu01Data({ ...menu01Data, fechaNacimiento: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Edad: </label>
                            <input type="text" value={menu01Data.edad} readOnly class="form-control" placeholder="" />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Lugar de nacimiento: </label>
                            <input type="text" class="form-control" placeholder="" value={menu01Data.lugarNacimiento} onChange={(e) => setMenu01Data({ ...menu01Data, lugarNacimiento: e.target.value })} />
                        </div>

                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Estado civil: </label>
                            <Select options={maritalEstatus} class="form-control" value={maritalEstatusSelect} onChange={(e) => setMaritalEstatusSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Sexo: </label>
                            <Select options={genders} class="form-control" value={gendersSelect} onChange={(e) => setGendersSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Escolaridad: </label>
                            <input type="text" class="form-control" placeholder="" value={menu01Data.escolaridad} onChange={(e) => setMenu01Data({ ...menu01Data, escolaridad: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">CURP:</label>
                            <input type="text" class="form-control" placeholder="" value={menu01Data.CURP} onChange={(e) => setMenu01Data({ ...menu01Data, CURP: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">No. Credencial:</label>
                            <input type="text" class="form-control" placeholder="" value={menu01Data.NoCredencial} onChange={(e) => setMenu01Data({ ...menu01Data, NoCredencial: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">RFC:</label>
                            <input type="text" class="form-control" placeholder="" value={menu01Data.RFC} onChange={(e) => setMenu01Data({ ...menu01Data, RFC: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Dependientes económicos:</label>
                            <input type="text" class="form-control" placeholder="" value={menu01Data.dependientes} onChange={(e) => setMenu01Data({ ...menu01Data, dependientes: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Antiguedad en el domicilio:</label>
                            <input type="text" class="form-control" placeholder="" value={menu01Data.antiguedad} onChange={(e) => setMenu01Data({ ...menu01Data, antiguedad: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Nacionalidad:</label>
                            <input type="text" class="form-control" placeholder="" value={menu01Data.nacionalidad} onChange={(e) => setMenu01Data({ ...menu01Data, nacionalidad: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ display: "flex", alignItems: "center", width: "35%" }}>
                            <input class="form-check-input" type="checkbox" role="switch" id="switchCheckChecked" checked={active} onChange={() => setActive(!active)} />
                            <label class="form-check-label" for="switchCheckChecked" style={{ fontWeight: "bold", color: active ? "green" : "red" }}>{active ? "Activo" : "Inactivo"}</label>
                        </div>


                    </div>
                    <div className={styles.containerForm} style={{ display: menuActive == "menu02" ? "flex" : "none" }}>

                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Nombre(s) (Cónyuge):</label>
                            <input type="text" class="form-control" placeholder="Nombre" value={menu02Data.name} onChange={(e) => setMenu02Data({ ...menu02Data, name: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">A. Paterno (Cónyuge):</label>
                            <input type="text" class="form-control" placeholder="A. Paterno" value={menu02Data.primerApellido} onChange={(e) => setMenu02Data({ ...menu02Data, primerApellido: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">A.Materno (Cónyuge):</label>
                            <input type="text" class="form-control" placeholder="A.Materno" value={menu02Data.segundoApellido} onChange={(e) => setMenu02Data({ ...menu02Data, segundoApellido: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Fecha de nacimiento</label>
                            <input type="date" data-date-format="DD MMMM YYYY" class="form-control" placeholder="" value={menu02Data.fechaNacimiento} onChange={(e) => setMenu02Data({ ...menu02Data, fechaNacimiento: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Número de telefono: *</label>
                            <input type="number" class="form-control" placeholder="1234567890" value={menu02Data.phone} onChange={(e) => setMenu02Data({ ...menu02Data, phone: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Ocupación</label>
                            <input type="text" class="form-control" placeholder="Ocupacion" value={menu02Data.ocupacion} onChange={(e) => setMenu02Data({ ...menu02Data, ocupacion: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Nombre empresa:</label>
                            <input type="text" class="form-control" placeholder="Empresa" value={menu02Data.empresa} onChange={(e) => setMenu02Data({ ...menu02Data, empresa: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Ingreso Mensual</label>
                            <input type="number" class="form-control" placeholder="$" value={menu02Data.ingreso} onChange={(e) => setMenu02Data({ ...menu02Data, ingreso: e.target.value })} />
                        </div>


                    </div>
                    <div className={styles.containerForm} style={{ display: menuActive == "menu03" ? "flex" : "none" }}>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label class="form-label">Tipo de domicilio:</label>
                            <Select options={addressTypes} class="form-control" placeholder="Domicilio" value={addressTypeSelect} onChange={(e) => setAddressTypeSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label class="form-label">No. de personas que viven en el domicilio:</label>
                            <input type="text" class="form-control" placeholder="#" value={menu03Data.personas} onChange={(e) => setMenu03Data({ ...menu03Data, personas: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <label class="form-label">Caracteristicas de la vivienda:</label>
                            <textarea type="text" rows="3" className='form-control' placeholder="" value={menu03Data.vivienda} onChange={(e) => setMenu03Data({ ...menu03Data, vivienda: e.target.value })}></textarea>
                        </div>
                        <div className={styles.itemForm} style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                            <div style={{ width: "200px", textAlign: "center", fontWeight: "bold", color: "#4B8FB5" }}>ENTRE LAS CALLES</div>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                        </div>

                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label class="form-label">Vialidad 1:</label>
                            <input type="text" class="form-control" placeholder="Vialidad" value={menu03Data.vialidad1} onChange={(e) => setMenu03Data({ ...menu03Data, vialidad1: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label class="form-label">Vialidad 2:</label>
                            <input type="text" class="form-control" placeholder="Vialidad" value={menu03Data.vialidad2} onChange={(e) => setMenu03Data({ ...menu03Data, vialidad2: e.target.value })} />
                        </div>

                        <div className={styles.FileContainer}>
                            <div className={styles.file50}>
                                <div className={styles.subTitle}>
                                    Subir Archivos
                                </div>
                                <form className={styles.formFileUpload} onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
                                    <input accept=".png, .jpg, .jpeg" ref={inputRef} onChange={handleChange} type="file" className={styles.inputFileUpload} multiple={true} />
                                    <label className={styles.labelFileUpload} style={{ backgroundColor: dragActive ? "rgb(212, 236, 255)" : "" }}>
                                        <div>
                                            <div>arrastra y suelta o <button onClick={onButtonClick} className={styles.uploadButton}>selecciona</button> los archivos a subir.</div>
                                        </div>
                                        {dragActive && <div className={styles.dragElement} onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div>}

                                    </label>
                                </form>
                            </div>

                            <div className={styles.file50} style={{ display: file.length > 0 || fileFront2.length > 0 ? "" : "none" }}>
                                <div className={styles.subTitle}>
                                    Archivos subidos ({fileFront.length + fileFront2.length}) <div onClick={() => downloadImagesAsZip("VERDOM")} className={styles.btnDown}><FaFileDownload /></div>
                                </div>
                                <div className={styles.imageContainer}>
                                    {fileFront}
                                    {fileFront2}
                                </div>

                            </div>
                        </div>


                    </div>
                    <div className={styles.containerForm} style={{ display: menuActive == "menu04" ? "flex" : "none" }}>
                        <div className={styles.itemForm} style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                            <div style={{ width: "220px", textAlign: "center", fontWeight: "bold", color: "#4B8FB5" }}>REFERENCIA FAMILIAR</div>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Nombre(s):</label>
                            <input type="text" class="form-control" placeholder="Nombre" value={menu04Data.fam_names} onChange={(e) => setMenu04Data({ ...menu04Data, fam_names: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">A. Paterno:</label>
                            <input type="text" class="form-control" placeholder="A. Paterno" value={menu04Data.fam_fathersLastName} onChange={(e) => setMenu04Data({ ...menu04Data, fam_fathersLastName: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">A.Materno:</label>
                            <input type="text" class="form-control" placeholder="A.Materno" value={menu04Data.fam_mothersLastName} onChange={(e) => setMenu04Data({ ...menu04Data, fam_mothersLastName: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Parentesco:</label>
                            <input type="text" class="form-control" placeholder="Parentesco" value={menu04Data.fam_relationship} onChange={(e) => setMenu04Data({ ...menu04Data, fam_relationship: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Estado</label>
                            <Select options={estados} class="form-control" placeholder="Estado" value={stateSelectFam} onChange={(e) => handleChangeState("FAM", e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Municipio</label>
                            <Select options={municipalFilterFam} class="form-control" placeholder="Municipio" value={municipalSelectFam} onChange={(e) => handleChangeMunicipal("FAM", e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Codigo Postal</label>
                            <Select options={postalCodeFilterFam} class="form-control" placeholder="Código Postal" value={postalCodeSelectFam} onChange={(e) => setPostalCodeSelectFam(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Domicilio</label>
                            <input type="text" class="form-control" placeholder="Domicilio" value={menu04Data.fam_addressDescription} onChange={(e) => setMenu04Data({ ...menu04Data, fam_addressDescription: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">No Ext/Int:</label>
                            <input type="text" class="form-control" placeholder="No Ext/Int" value={menu04Data.fam_extIntNumber} onChange={(e) => setMenu04Data({ ...menu04Data, fam_extIntNumber: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Número de telefono</label>
                            <input type="numbrt" class="form-control" placeholder="1234567890" value={menu04Data.fam_phoneNumber} onChange={(e) => setMenu04Data({ ...menu04Data, fam_phoneNumber: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                            <div style={{ width: "220px", textAlign: "center", fontWeight: "bold", color: "#4B8FB5" }}>REFERENCIA PERSONAL</div>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Nombre(s):</label>
                            <input type="text" class="form-control" placeholder="Nombre" value={menu04Data.per_names} onChange={(e) => setMenu04Data({ ...menu04Data, per_names: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">A. Paterno:</label>
                            <input type="text" class="form-control" placeholder="A. Paterno" value={menu04Data.per_fathersLastName} onChange={(e) => setMenu04Data({ ...menu04Data, per_fathersLastName: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">A.Materno:</label>
                            <input type="text" class="form-control" placeholder="A.Materno" value={menu04Data.per_mothersLastName} onChange={(e) => setMenu04Data({ ...menu04Data, per_mothersLastName: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Parentesco:</label>
                            <input type="text" class="form-control" placeholder="Parentesco" value={menu04Data.per_relationship} onChange={(e) => setMenu04Data({ ...menu04Data, per_relationship: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Estado</label>
                            <Select options={estados} class="form-control" placeholder="Estado" value={stateSelectPer} onChange={(e) => handleChangeState("PER", e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Municipio</label>
                            <Select options={municipalFilterPer} class="form-control" placeholder="Municipio" value={municipalSelectPer} onChange={(e) => handleChangeMunicipal("PER", e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Codigo Postal</label>
                            <Select options={postalCodeFilterPer} class="form-control" placeholder="Código Postal" value={postalCodeSelectPer} onChange={(e) => setPostalCodeSelectPer(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Domicilio</label>
                            <input type="text" class="form-control" placeholder="Domicilio" value={menu04Data.per_addressDescription} onChange={(e) => setMenu04Data({ ...menu04Data, per_addressDescription: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">No Ext/Int:</label>
                            <input type="text" class="form-control" placeholder="No Ext/Int" value={menu04Data.per_extIntNumber} onChange={(e) => setMenu04Data({ ...menu04Data, per_extIntNumber: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Número de telefono</label>
                            <input type="number" class="form-control" placeholder="1234567890" value={menu04Data.per_phoneNumber} onChange={(e) => setMenu04Data({ ...menu04Data, per_phoneNumber: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                            <div style={{ width: "420px", textAlign: "center", fontWeight: "bold", color: "#4B8FB5" }}>DATOS GENERALES DE LA ACTIVIDAD O NEGOCIO</div>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "75%" }}>
                            <label class="form-label">Nombre del negocio:</label>
                            <input type="text" class="form-control" placeholder="Nombre" value={menu04Data.neg_businessName} onChange={(e) => setMenu04Data({ ...menu04Data, neg_businessName: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Actividad o giro:</label>
                            <input type="text" class="form-control" placeholder="Actividad" value={menu04Data.neg_businessActivity} onChange={(e) => setMenu04Data({ ...menu04Data, neg_businessActivity: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label class="form-label">Antiguedad del negocio:</label>
                            <input type="text" class="form-control" placeholder="Antiguedad del negocio" value={menu04Data.neg_antiquityOfTheBusiness} onChange={(e) => setMenu04Data({ ...menu04Data, neg_antiquityOfTheBusiness: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">RFC:</label>
                            <input type="text" class="form-control" placeholder="RFC" value={menu04Data.neg_federalTaxpayerRegistry} onChange={(e) => setMenu04Data({ ...menu04Data, neg_federalTaxpayerRegistry: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "25%" }}>
                            <label class="form-label">Ingreso mensual:</label>
                            <input type="number" class="form-control" placeholder="Ingreso mensual" value={menu04Data.neg_monthlyIncome} onChange={(e) => setMenu04Data({ ...menu04Data, neg_monthlyIncome: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Estado</label>
                            <Select options={estados} class="form-control" placeholder="Estado" value={stateSelectNeg} onChange={(e) => handleChangeState("NEG", e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Municipio</label>
                            <Select options={municipalFilterNeg} class="form-control" placeholder="Municipio" value={municipalSelectNeg} onChange={(e) => handleChangeMunicipal("NEG", e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Codigo Postal</label>
                            <Select options={postalCodeFilterNeg} class="form-control" placeholder="Código Postal" value={postalCodeSelectNeg} onChange={(e) => setPostalCodeSelectNeg(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Domicilio</label>
                            <input type="text" class="form-control" placeholder="Domicilio" value={menu04Data.neg_addressDescription} onChange={(e) => setMenu04Data({ ...menu04Data, neg_addressDescription: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">No Ext/Int:</label>
                            <input type="text" class="form-control" placeholder="No Ext/Int" value={menu04Data.neg_extIntNumber} onChange={(e) => setMenu04Data({ ...menu04Data, neg_extIntNumber: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%" }}>
                            <label class="form-label">Número de telefono</label>
                            <input type="number" class="form-control" placeholder="1234567890" value={menu04Data.neg_phoneNumber} onChange={(e) => setMenu04Data({ ...menu04Data, neg_phoneNumber: e.target.value })} />
                        </div>
                    </div>
                    <div className={styles.containerForm} style={{ display: menuActive == "menu05" ? "flex" : "none" }}>
                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <label class="form-label">Garantia de crédito:</label>
                            <textarea type="text" rows="3" className='form-control' placeholder="" value={menu05Data.descriptionWar} onChange={(e) => setMenu05Data({ ...menu05Data, descriptionWar: e.target.value })}></textarea>
                        </div>
                        <div className={styles.FileContainer}>
                            <div className={styles.file50}>
                                <div className={styles.subTitle}>
                                    Subir Fotografía
                                </div>
                                <form className={styles.formFileUpload} onDragEnter={handleDragGT} onSubmit={(e) => e.preventDefault()}>
                                    <input accept=".png, .jpg, .jpeg" ref={inputRefGT} onChange={handleChangeGT} type="file" className={styles.inputFileUpload} multiple={true} />
                                    <label className={styles.labelFileUpload} style={{ backgroundColor: dragActiveGT ? "rgb(212, 236, 255)" : "" }}>
                                        <div>
                                            <div>arrastra y suelta o <button onClick={onButtonClickGT} className={styles.uploadButton}>selecciona</button> los archivos a subir.</div>
                                        </div>
                                        {dragActiveGT && <div className={styles.dragElement} onDragEnter={handleDragGT} onDragLeave={handleDragGT} onDragOver={handleDragGT} onDrop={handleDropGT}></div>}

                                    </label>
                                </form>
                            </div>

                            <div className={styles.file50} style={{ display: fileGT.length > 0 || fileFrontGT2.length > 0 ? "" : "none" }}>
                                <div className={styles.subTitle}>
                                    Archivos subidos ({fileFrontGT.length + fileFrontGT2.length}) <div onClick={() => downloadImagesAsZip("GARAN")} className={styles.btnDown}><FaFileDownload /></div>
                                </div>
                                <div className={styles.imageContainer}>
                                    {fileFrontGT}
                                    {fileFrontGT2}
                                </div>

                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                            <div style={{ width: "350px", textAlign: "center", fontWeight: "bold", color: "#4B8FB5" }}>PERSONA POLITICAMENTE EXPUESTA</div>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                        </div>

                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <label class="form-label">{questions && questions.length > 0 ? questions[0].description : ""}</label>
                        </div>
                        <div className={styles.itemForm} style={{ width: "20%", display: "flex", alignItems: "center" }}>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value={menu05Data.answerBool01} id="check01" checked={menu05Data.answerBool01} onChange={(e) => setMenu05Data({ ...menu05Data, answerBool01: true })} />
                                <label class="form-check-label" for="check01">
                                    SI
                                </label>
                            </div>
                            <div class="form-check" style={{ marginLeft: "20px" }}>
                                <input class="form-check-input" type="checkbox" value={!menu05Data.answerBool01} id="check02" checked={!menu05Data.answerBool01} onChange={(e) => setMenu05Data({ ...menu05Data, answerBool01: false })} />
                                <label class="form-check-label" for="check02">
                                    NO
                                </label>
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "80%", display: "flex", alignItems: "center" }}>
                            <label class="form-label">{questions && questions.length > 0 ? questions[0].descriptionDetails + ":" : ""}</label>&nbsp;&nbsp;&nbsp;
                            <input disabled={!menu05Data.answerBool01} type="text" class="form-control" placeholder="" value={menu05Data.answerString01} onChange={(e) => setMenu05Data({ ...menu05Data, answerString01: e.target.value })} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <label class="form-label">{questions && questions.length > 1 ? questions[1].description : ""}</label>
                        </div>
                        <div className={styles.itemForm} style={{ width: "20%", display: "flex", alignItems: "center" }}>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="check03" checked={menu05Data.answerBool02} onChange={(e) => setMenu05Data({ ...menu05Data, answerBool02: true })} />
                                <label class="form-check-label" for="check03">
                                    SI
                                </label>
                            </div>
                            <div class="form-check" style={{ marginLeft: "20px" }}>
                                <input class="form-check-input" type="checkbox" value="" id="check04" checked={!menu05Data.answerBool02} onChange={(e) => setMenu05Data({ ...menu05Data, answerBool02: false })} />
                                <label class="form-check-label" for="check04">
                                    NO
                                </label>
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "80%", display: "flex", alignItems: "center" }}>
                            <label class="form-label">{questions && questions.length > 1 ? questions[1].descriptionDetails + ":" : ""}</label>&nbsp;&nbsp;&nbsp;
                            <input disabled={!menu05Data.answerBool02} type="text" class="form-control" placeholder="" value={menu05Data.answerString02} onChange={(e) => setMenu05Data({ ...menu05Data, answerString02: e.target.value })} />
                        </div>



                    </div>
                    <div className={styles.containerForm} style={{ display: menuActive == "menu06" ? "flex" : "none" }}>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label class="form-label">AVAL</label>
                            <Select isClearable options={avals} class="form-control" placeholder="Seleccione un AVAL" value={avalSelect} onChange={(e) => setAvalSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ display: "flex", alignItems: "end", paddingBottom: "15px" }}>
                            <button className={showCreateAval ? 'btn btn-sm btn-danger' : 'btn btn-sm btn-success'} onClick={() => setShowCreateAval(!showCreateAval)}>{showCreateAval ? <FaMinus /> : <FaPlus />}</button>
                        </div>
                        <div className={`${styles.containerForm} animate__animated animate__slideInUp`} style={{ width: "100%", display: showCreateAval ? "flex" : "none" }}>
                            <div className={styles.itemForm} style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                                <div style={{ width: "220px", textAlign: "center", fontWeight: "bold", color: "#4B8FB5" }}>AGREGAR AVAL</div>
                                <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                            </div>
                            <div className={styles.itemForm} style={{ width: "25%" }}>
                                <label class="form-label">Nombre(s):</label>
                                <input type="text" class="form-control" placeholder="Nombre" value={menu06Data.names} onChange={(e) => setMenu06Data({ ...menu06Data, names: e.target.value })} />
                            </div>
                            <div className={styles.itemForm} style={{ width: "25%" }}>
                                <label class="form-label">A. Paterno:</label>
                                <input type="text" class="form-control" placeholder="A. Paterno" value={menu06Data.fathersLastName} onChange={(e) => setMenu06Data({ ...menu06Data, fathersLastName: e.target.value })} />
                            </div>
                            <div className={styles.itemForm} style={{ width: "25%" }}>
                                <label class="form-label">A.Materno:</label>
                                <input type="text" class="form-control" placeholder="A.Materno" value={menu06Data.mothersLastName} onChange={(e) => setMenu06Data({ ...menu06Data, mothersLastName: e.target.value })} />
                            </div>
                            <div className={styles.itemForm} style={{ width: "25%" }}>
                                <label class="form-label">Sexo:</label>
                                <Select options={genders} class="form-control" value={gendersSelectAval} onChange={(e) => setGendersSelectAval(e)} />
                            </div>
                            <div className={styles.itemForm} style={{ width: "33%" }}>
                                <label class="form-label">Estado</label>
                                <Select options={estados} class="form-control" placeholder="Estado" value={stateSelectAval} onChange={(e) => handleChangeState("AVAL", e)} />
                            </div>
                            <div className={styles.itemForm} style={{ width: "33%" }}>
                                <label class="form-label">Municipio</label>
                                <Select options={municipalFilterAval} class="form-control" placeholder="Municipio" value={municipalSelectAval} onChange={(e) => handleChangeMunicipal("AVAL", e)} />
                            </div>
                            <div className={styles.itemForm} style={{ width: "33%" }}>
                                <label class="form-label">Codigo Postal</label>
                                <Select options={postalCodeFilterAval} class="form-control" placeholder="Código Postal" value={postalCodeSelectAval} onChange={(e) => setPostalCodeSelectAval(e)} />
                            </div>
                            <div className={styles.itemForm} style={{ width: "25%" }}>
                                <label class="form-label">CURP:</label>
                                <input type="text" class="form-control" placeholder="" value={menu06Data.populationRegistrationCode} onChange={(e) => setMenu06Data({ ...menu06Data, populationRegistrationCode: e.target.value })} />
                            </div>
                            <div className={styles.itemForm} style={{ width: "25%" }}>
                                <label class="form-label">No. Credencial:</label>
                                <input type="text" class="form-control" placeholder="" value={menu06Data.credentialNumber} onChange={(e) => setMenu06Data({ ...menu06Data, credentialNumber: e.target.value })} />
                            </div>
                            <div className={styles.itemForm} style={{ width: "25%" }}>
                                <label class="form-label">Fecha de nacimiento: </label>
                                <input type="date" data-date-format="DD MMMM YYYY" class="form-control" placeholder="" value={menu06Data.dateOfBirth} onChange={(e) => setMenu06Data({ ...menu06Data, dateOfBirth: e.target.value })} />
                            </div>
                            <div className={styles.itemForm} style={{ width: "33%" }}>
                                <label class="form-label">Domicilio: *</label>
                                <input type="text" class="form-control" placeholder="Domicilio" value={menu06Data.addressDescription} onChange={(e) => setMenu06Data({ ...menu06Data, addressDescription: e.target.value })} />
                            </div>
                            <div className={styles.itemForm} style={{ width: "33%" }}>
                                <label class="form-label">Referencia (Entre calles): *</label>
                                <input type="text" class="form-control" placeholder="Referencias:" value={menu06Data.addressReferences} onChange={(e) => setMenu06Data({ ...menu06Data, addressReferences: e.target.value })} />
                            </div>
                            <div className={styles.itemForm} style={{ width: "33%" }}>
                                <label class="form-label">Número de telefono: *</label>
                                <input type="number" class="form-control" placeholder="1234567890" value={menu06Data.phoneNumber} onChange={(e) => setMenu06Data({ ...menu06Data, phoneNumber: e.target.value })} />
                            </div>
                            <div className={styles.itemForm}>
                                <button className='btn btn-success' onClick={() => handleCreateAval()}>Agregar</button>&nbsp;&nbsp;&nbsp;
                                <button className='btn btn-danger' onClick={() => setShowCreateAval(false)} >Cancelar</button>
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "2px" }}></div>
                        </div>

                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <label class="form-label">Dirección Aval:</label>
                            <input readOnly type="text" class="form-control" placeholder="" value={avalSelect && avalSelect.addressDescription ? avalSelect.addressDescription : ""} onChange={(e) => setDireccion(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "40%" }}>
                            <label class="form-label">Teléfono Aval:</label>
                            <input readOnly type="text" class="form-control" placeholder="" value={avalSelect && avalSelect.phoneNumber ? avalSelect.phoneNumber : ""} onChange={(e) => setDireccion(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "60%" }}>
                            <label class="form-label">Referencia (Entre calles):</label>
                            <input readOnly type="text" class="form-control" placeholder="" value={avalSelect && avalSelect.addressReferences ? avalSelect.addressReferences : ""} onChange={(e) => setDireccion(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ display: avalSelect !== null ? "flex" : "none", width: "100%", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                            <div style={{ width: "220px", textAlign: "center", fontWeight: "bold", color: "#4B8FB5" }}>DOCUMENTOS AVAL</div>
                            <div style={{ flex: 1, backgroundColor: "#2797D5", height: "3px" }}></div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "50%", display: avalSelect !== null ? "" : "none" }}>
                            <label class="form-label">Tipo de documento:</label>
                            <Select options={documentsTypesAval} class="form-control" value={documentTypeAvalSelect} onChange={(e) => setDocumentTypeAvalSelect(e)} />
                        </div>
                        <div className={styles.FileContainer} style={{ display: avalSelect !== null ? "flex" : "none" }}>
                            <div className={styles.file50}>
                                <div className={styles.subTitle}>
                                    Subir Documentos
                                </div>
                                <form className={styles.formFileUpload} onDragEnter={handleDragAval} onSubmit={(e) => e.preventDefault()}>
                                    <input accept=".pdf" ref={inputRefAval} onChange={handleChangeAval} type="file" className={styles.inputFileUpload} multiple={false} />
                                    <label className={styles.labelFileUpload} style={{ backgroundColor: dragActiveAval ? "rgb(212, 236, 255)" : "" }}>
                                        <div>

                                            <div>arrastra y suelta o <button onClick={onButtonClickAval} className={styles.uploadButton}>selecciona</button> los archivos a subir.</div>
                                        </div>
                                        {dragActiveAval && <div className={styles.dragElement} onDragEnter={handleDragAval} onDragLeave={handleDragAval} onDragOver={handleDragAval} onDrop={handleDropAval}></div>}

                                    </label>
                                </form>
                            </div>

                            <div className={styles.file50} style={{ display: fileAval.length > 0 || fileFrontAval2.length > 0 ? "" : "none" }}>
                                <div className={styles.subTitle}>
                                    Archivos subidos ({fileFrontAval.length + fileFrontAval2.length}) <div onClick={() => downloadPDFAsZip("AVAL")} className={styles.btnDown}><FaFileDownload /></div>
                                </div>
                                <div className={styles.imageContainer}>
                                    {fileFrontAval}
                                    {fileFrontAval2}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className={styles.containerForm} style={{ display: menuActive == "menu07" ? "flex" : "none" }}>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label class="form-label">Tipo de documento:</label>
                            <Select options={documentsTypesClient} class="form-control" value={documentTypeClientSelect} onChange={(e) => setDocumentTypeClientSelect(e)} />
                        </div>
                        <div className={styles.FileContainer}>
                            <div className={styles.file50}>
                                <div className={styles.subTitle}>
                                    Subir Documentos
                                </div>
                                <form className={styles.formFileUpload} onDragEnter={handleDragCLT} onSubmit={(e) => e.preventDefault()}>
                                    <input accept=".pdf" ref={inputRefCLT} onChange={handleChangeCLT} type="file" className={styles.inputFileUpload} multiple={false} />
                                    <label className={styles.labelFileUpload} style={{ backgroundColor: dragActiveCLT ? "rgb(212, 236, 255)" : "" }}>
                                        <div>
                                            <div>arrastra y suelta o <button onClick={onButtonClickCLT} className={styles.uploadButton}>selecciona</button> los archivos a subir.</div>
                                        </div>
                                        {dragActiveCLT && <div className={styles.dragElement} onDragEnter={handleDragCLT} onDragLeave={handleDragCLT} onDragOver={handleDragCLT} onDrop={handleDropCLT}></div>}

                                    </label>
                                </form>
                            </div>

                            <div className={styles.file50} style={{ display: fileCLT.length > 0 || fileFrontCLT2.length > 0 ? "" : "none" }}>
                                <div className={styles.subTitle}>
                                    Archivos subidos ({fileFrontCLT.length + fileFrontCLT2.length}) <div onClick={() => downloadPDFAsZip("CLIENTE")} className={styles.btnDown}><FaFileDownload /></div>
                                </div>
                                <div className={styles.imageContainer}>
                                    {fileFrontCLT}
                                    {fileFrontCLT2}
                                </div>

                            </div>
                        </div>




                    </div>
                    <div className={styles.containerBtn}>
                        <button disabled={loading} style={{ display: clientId == 0 ? "none" : "" }} className='btn btn-success' onClick={handleAgregar}>{
                            loading ? (<div class="spinner-border spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>) : dataEdit != null ? "Editar" : "Guardar Todo"}</button>
                        <button disabled={loading} style={{ display: clientId == 0 ? "" : "none" }} className='btn btn-success' onClick={handleAgregarPersonalData}>{
                            loading ? (<div class="spinner-border spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>) : dataEdit != null ? "Editar" : "Guardar Datos personales"}</button>&nbsp;&nbsp;
                        <button disabled={loading} className='btn btn-danger' onClick={() => setShow(false)}>Cancelar</button>
                    </div>
                </div>
            </div>
            <ModalPDF
                show={showPDF}
                setShow={setShowPDF}
                pdfBase64={pdfbase64}
            ></ModalPDF>
        </>
    );
}